let posdataRefUrl = "";
let fedUrl = "";
let clientId = "";
let xapikey = "";
let redirectUri = "";
let syncWithProdFlag = "";

if(window.location.host.includes("referential.posdata.decathlon")) {

  posdataRefUrl = process.env.PROD_REF_URL
  fedUrl = process.env.PROD_FED_URL
  clientId = process.env.PROD_FED_CLIENT_ID
  xapikey = process.env.PROD_X_API_KEY
  syncWithProdFlag = false;

  if(window.location.host.includes("decathlon.io")) {

    redirectUri = 'https://referential.posdata.decathlon.io/accessToken/'

  } else {

    redirectUri = 'https://referential.posdata.decathlon.net/accessToken/'

  }

} else if(window.location.host.includes("referential.posdata-qualification.decathlon")) {

  posdataRefUrl = process.env.PREPROD_REF_URL
  fedUrl = process.env.PREPROD_FED_URL
  clientId = process.env.PREPROD_FED_CLIENT_ID
  xapikey = process.env.PREPROD_X_API_KEY
  syncWithProdFlag = true;

  if(window.location.host.includes("decathlon.io")) {

    redirectUri = 'https://referential.posdata-qualification.decathlon.io/accessToken/'

  } else {

    redirectUri = 'https://referential.posdata-qualification.decathlon.net/accessToken/'

  }

} else {

  posdataRefUrl = process.env.LOCAL_REF_URL
  fedUrl = process.env.PREPROD_FED_URL
  clientId = process.env.LOCAL_FED_CLIENT_ID
  redirectUri='http://localhost:8081/accessToken/'
}


const parameters = {
  clientId,
  redirectUri,
  posdataRefUrl,
  fedUrl,
  xapikey,
  syncWithProdFlag
};

export {
  parameters
}



// WEBPACK FOOTER //
// ./src/parameters.js